(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("osdetection", [], factory);
	else if(typeof exports === 'object')
		exports["osdetection"] = factory();
	else
		root["osdetection"] = factory();
})(this, () => {
return 